import { Form, Row } from 'antd';
import styled from 'styled-components';
import StaffPicker from './StaffPicker';
import SwitchCalendarType from './SwitchCalendarType';
import TypeItemPicker from './TypeItemPicker';
import InputSearchCustomer from './InputSearchCustomer';
import DateViewControls from 'components/DateViewControls';
import dayjs from 'dayjs';
import { CALENDAR_VIEW_TYPE } from 'features/appointment/services/constants';
import { useAppDispatch } from 'store/hooks';
import appointmentActions from 'features/appointment/services/actions';
import { useEffect } from 'react';

type Props = {
  v2?: boolean;
};

interface FilterV2FormValues {
  timePeriod: {
    startTime: dayjs.Dayjs;
    endTime: dayjs.Dayjs;
  };
  viewType: string;
}

const TableFilter = ({ v2 }: Props) => {
  const [form] = Form.useForm<FilterV2FormValues>();
  const dispatch = useAppDispatch();

  const timePeriod = Form.useWatch('timePeriod', form);

  useEffect(() => {
    if (!timePeriod) return;

    dispatch(
      appointmentActions.setTableParams({
        startTime: timePeriod.startTime.format('MM-DD-YYYY'),
        endTime: timePeriod.endTime.format('MM-DD-YYYY'),
      }),
    );
  }, [timePeriod]);
  
  if (v2) {
    return (
      <>
        <InputSearchCustomer />
        <TypeItemPicker v2 />
        <StaffPicker v2 />
        <Form
          form={form}
          initialValues={{
            timePeriod: { startTime: dayjs(), endTime: dayjs() },
            viewType: CALENDAR_VIEW_TYPE.DAY_VIEW,
          }}
        >
          <DateViewControls />
        </Form>
      </>
    );
  }
  return (
    <CalendarFilterStyled align={'middle'}>
      <TypeItemPicker />
      <StaffPicker />
      <SwitchCalendarType />
    </CalendarFilterStyled>
  );
};

export default TableFilter;

const CalendarFilterStyled = styled(Row)`
  gap: 12px;
`;
